import { faDigits } from '../../lib/numerals'
import { parseIsoDate } from '../../lib/jalali'
import { MONTHS_FA } from './constants'

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function isoToDateKey(iso) {
  const d = new Date(iso)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function toDatetimeLocal(iso) {
  const d = new Date(iso)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function formatShortDatetime(iso) {
  const d = new Date(iso)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}/${pad(d.getMonth()+1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function todayKey() {
  const d = new Date()
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
}

export function makeDayKey(year, month, day) {
  const pad = n => String(n).padStart(2, '0')
  return `${year}-${pad(month + 1)}-${pad(day)}`
}

// ─── Date display ─────────────────────────────────────────────────────────────
//
// The panel reads Gregorian (owner decision, 2026-10-13 — it used to be
// Jalali, S3-p). Month names are the Persian spellings of the Gregorian ones
// and digits are Persian per the numerals rule: a date is something read, not
// typed off a device. The wire was Gregorian all along (backend-nest ADR-0008).

/** `YYYY-MM-DD` (a Tehran calendar day) → `۲۰۲۶/۰۹/۲۸`; anything else → `—`. */
export function formatDayCompact(ymd) {
  const g = parseIsoDate(ymd)
  if (!g) return '—'
  return faDigits(`${g.year}/${String(g.month).padStart(2, '0')}/${String(g.day).padStart(2, '0')}`)
}

/** ISO instant → `۲۸ سپتامبر ۲۰۲۶` in the browser's local day; null/invalid → `—`. */
export function formatDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return `${faDigits(d.getDate())} ${MONTHS_FA[d.getMonth()]} ${faDigits(d.getFullYear())}`
}

/** ISO instant → `۲۸ سپتامبر ۲۰۲۶ ۱۴:۰۵`; null/invalid → `—`. */
export function formatDatetime(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const pad = n => String(n).padStart(2, '0')
  return `${formatDate(iso)} ${faDigits(`${pad(d.getHours())}:${pad(d.getMinutes())}`)}`
}

/** Whole milliseconds → `m:ss` in Persian digits (V3-p), floored like a player shows it: 2800 → `۰:۰۲`, 65000 → `۱:۰۵`; null/negative → `—`. */
export function formatDurationMs(ms) {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return '—'
  const total = Math.floor(ms / 1000)
  return faDigits(`${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`)
}
